// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { swiffyslider } from "swiffy-slider"
import ahoy from "ahoy.js"
import "chartkick/chart.js"

window.swiffyslider = swiffyslider;
window.addEventListener("load", () => {
  window.swiffyslider.init();
});


import "@rails/actiontext"  // required for active storage to support attachments
import "@37signals/lexxy"

